export default __webpack_public_path__ + "./images/gq.ab432c07.png";